module.exports = __webpack_public_path__ + "static/img/leave.7573338a.jpg";